import './grid-line-buttons.scss';

interface Props {
    children?: React.ReactNode;
}

const GridLineButtons: React.FC<Props> = ({ children }) => {
    return (
        <div className="grid-line-buttons">
            {children}
        </div>
    );
}

export default GridLineButtons;
